export default "/profile/images/instruction-1-ua.webp?d9b2737104010004618ab5b45566213c";